import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import BWModels from "@benjamin-west-rpm2/benjamin-west-models";

import { FormGrid, FormikForm } from "../../../../forms";
import { ActionButtons } from "../../../../forms/ActionButtons";
import { inputs } from "../../../../inputs/inputConfigs";
import { scaleDataComponentId } from "./ScaleContainer";

const Wrapper = styled.div``;

const fields = {
  groups: [
    {
      items: [
        {
          input: inputs.name,
          grid: { xs: 12 },
        },
      ],
    },
  ],
};

export const ScaleForm = ({
  initialValues,
  onSubmit,
  onCancel,
  sendButtonText,
}) => {
  return (
    <FormikForm
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={BWModels.loadSchema("Scale")}
    >
      {({ handleSubmit, ...formikProps }) => (
        <Wrapper>
          <FormGrid fields={fields} {...formikProps} />
          <ActionButtons
            onSend={handleSubmit}
            onCancel={onCancel}
            sendButtonText={sendButtonText}
            listeners={[scaleDataComponentId]}
            isModal
          />
        </Wrapper>
      )}
    </FormikForm>
  );
};

ScaleForm.propTypes = {
  initialValues: PropTypes.shape({ name: PropTypes.string }).isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  sendButtonText: PropTypes.string.isRequired,
};

export default ScaleForm;
